import * as React from 'react';
import { TextAlignment } from '../../data/TextAlignment';

interface OptionProps {
  value: TextAlignment;
  selected: boolean;
  onSelect: (value: TextAlignment) => void;
}

const OptionView: React.FunctionComponent<OptionProps> = props => {
  return (
    <li
      className={props.selected ? 'text-aligment-option--selected' : undefined}
      onClick={props.selected ? undefined : () => props.onSelect(props.value)}
    >
      <img src={`/media/icons/align-${props.value}.svg`} />
    </li>
  );
};

interface Props {
  horizontalAlignment: TextAlignment;
  verticalAlignment: TextAlignment;
  onChange: (property: string, value: TextAlignment[]) => void;
}

const TextAlignmentSelect: React.FunctionComponent<Props> = props => {
  const horizontalOptions = [
    TextAlignment.Left,
    TextAlignment.Center,
    TextAlignment.Right
  ];
  const verticalOptions = [
    TextAlignment.Top,
    TextAlignment.Middle,
    TextAlignment.Bottom
  ];
  return (
    <div className="text-aligment-select">
      <ul className="text-aligment-select--horizontal">
        {horizontalOptions.map(item => (
          <OptionView
            value={item}
            key={item}
            selected={item === props.horizontalAlignment}
            onSelect={(value: TextAlignment) =>
              props.onChange('alignment', [value, props.verticalAlignment])
            }
          />
        ))}
      </ul>
      <ul className="text-aligment-select--vertical">
        {verticalOptions.map(item => (
          <OptionView
            value={item}
            key={item}
            selected={item === props.verticalAlignment}
            onSelect={(value: TextAlignment) =>
              props.onChange('alignment', [props.horizontalAlignment, value])
            }
          />
        ))}
      </ul>
    </div>
  );
};

export { TextAlignmentSelect };



// WEBPACK FOOTER //
// ./src/controller/components/TextAlignmentSelect.tsx